import React from "react";
import ReactECharts from "echarts-for-react";

export default function DualHorizontalBarCharts({
  productData,
  nonProductData,
}) {
  const options = {
    title: [
      {
        text: "Primary Complaint Areas",
        left: "left",
        textStyle: {
          fontFamily: "Uni Neue",
          fontSize: 16,
          fontWeight: "600",
        },
      },
      {
        text: "Product",
        left: "20%",
        top: "10%",
        bottom: "20%",
        textAlign: "center",
        textStyle: {
          fontFamily: "Uni Neue",
          fontSize: 14,
          fontWeight: "400",
        },
        subtextStyle: {
          fontFamily: "Uni Neue",
          fontSize: 12,
          fontWeight: "400",
        },
      },
      {
        text: "Non-Product",
        left: "75%",
        top: "10%",
        bottom: "20%",
        textAlign: "center",
        textStyle: {
          fontFamily: "Uni Neue",
          fontSize: 14,
          fontWeight: "400",
        },
        subtextStyle: {
          fontFamily: "Uni Neue",
          fontSize: 12,
          fontWeight: "400",
        },
      },
    ],
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: [
      {
        left: "10%",
        right: "55%",
        top: "20%",
        bottom: "10%",
        containLabel: true,
      },
      {
        left: "55%",
        right: "10%",
        top: "20%",
        bottom: "10%",
        containLabel: true,
      },
    ],
    xAxis: [
      {
        type: "value",
        gridIndex: 0,
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      {
        type: "value",
        gridIndex: 1,
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
    ],
    yAxis: [
      {
        type: "category",
        gridIndex: 0,
        data: productData.map((item) => item.name),
        axisLabel: {
          fontSize: 9,
          width: 50,
          overflow: "truncate",
        },
      },
      {
        type: "category",
        gridIndex: 1,
        data: nonProductData.map((item) => item.name),
        axisLabel: {
          fontSize: 9,
          width: 50,
          overflow: "truncate",
        },
      },
    ],
    series: [
      {
        name: "Product Complaints",
        type: "bar",
        data: productData.map((item) => item.value),
        xAxisIndex: 0,
        yAxisIndex: 0,
        barWidth: 10,
        itemStyle: {
          barBorderRadius: [0, 7, 7, 0],
          color: "#FFD772",
        },
        label: {
          show: true,
          position: "right",
        },
      },
      {
        name: "Non-Product Complaints",
        type: "bar",
        data: nonProductData.map((item) => item.value),
        xAxisIndex: 1,
        yAxisIndex: 1,
        barWidth: 10,
        itemStyle: {
          barBorderRadius: [0, 7, 7, 0],
          color: "#9482FF",
        },
        label: {
          show: true,
          position: "right",
        },
      },
    ],
  };

  if (Math.max(productData.length, nonProductData.length) > 7) {
    options.dataZoom = [
      {
        type: "slider",
        yAxisIndex: [0, 1],
        start:
          100 - (7 / Math.max(productData.length, nonProductData.length)) * 100,
        end: 100,
        width: 10,
        handleSize: 5,
        showDetail: false,
        fillerColor: "#2A5775",
        backgroundColor: "#ccc",
        handleColor: "#2A5775",
        zoomOnMouseWheel: false,
        moveOnMouseMove: false,
        moveOnMouseWheel: false,
        right: 0,
      },
    ];
  }
  return (
    <div>
      <ReactECharts option={options} style={{ height: 250, width: 350 }} />
    </div>
  );
}
